import TextInput from 'components/atoms/form/TextInput/TextInput'
import ToggleSwitch from 'components/atoms/form/ToggleSwitch/ToggleSwitch'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import {isObjectEmpty, isCompletedHotelInfoHistory} from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import PetPolicyService from '../../../../services/PetPolicyService'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './PetPolicy.scss'

class PetPolicy extends Component {

  constructor(props) {
    super(props)
    const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY);

    this.state = {
      hotelCode: getSessionItem(SessionConst.HOTEL_CODE),
      hotelInfo: getSessionItem(SessionConst.HOTEL_INFO),
      hotelCurrency: getSessionItem(SessionConst.HOTEL_CURRENCY),
      continueFlow: this.props.history.location?.state?.continueFlow,
      initialValues: this.initialValues,
      isLoading: true,
      loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
      distanceUnits: getSessionItem(SessionConst.DISTANCE_UNIT),
      distanceUnitsLabel: getSessionItem(SessionConst.DISTANCE_UNIT_LABEL),
      weightUnit: getSessionItem(SessionConst.WEIGHT_UNIT),
      hotelInfoCompletedHistory: hotelInfoCompletedHistory
    }
  }

  initialValues = {
    isPets: false,
    isPetsCharged: false,
    chargeAmount: 0,
    depositAmount: 0,
    isDeposit: false,
    maxPetCount: false,
    maxPetSize: false,
    kennel: FormConst.VALUE_NO_KENNEL,
    petCount: '0',
    petSize: '0',
    depositRefundable: false,
    distance: 0,
    amenityCode: FormConst.AMENITY_CODE_KENN,
    chargeType: '',
    depositFrequencyType: ''
  }

  validationSchema = Yup.object().shape({
    chargeAmount: Yup.number().when("isPetsCharged", {
      is: true,
      then: Yup.number()
        .required(FormConst.VALIDATION_ERROR_REQUIRED)
        .min(0.0001, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO)
    }),
    chargeType: Yup.string().when("isPetsCharged", {
      is: true,
      then: Yup.string()
        .required(FormConst.VALIDATION_ERROR_REQUIRED)
    }),
    depositAmount: Yup.number().when("isDeposit", {
      is: true,
      then: Yup.number()
        .required(FormConst.VALIDATION_ERROR_REQUIRED)
        .min(0.0001, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO)
    }),
    depositFrequencyType: Yup.string().when("isDeposit", {
      is: true,
      then: Yup.string()
        .required(FormConst.VALIDATION_ERROR_REQUIRED)
    }),
    petCount: Yup.number().when("maxPetCount", {
      is: true,
      then: Yup.number()
        .required(FormConst.VALIDATION_ERROR_REQUIRED)
        .min(0.0001, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO)
        .test("int", "Must be an integer", val => {
          return val % 1 === 0
        })
    }),
    petSize: Yup.number().when("maxPetSize", {
      is: true,
      then: Yup.number()
        .required(FormConst.VALIDATION_ERROR_REQUIRED)
        .min(0.0001, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO)
    }),
    kennel: Yup.string().when("isPets", {
      is: true,
      then: Yup.string()
        .required(FormConst.VALIDATION_ERROR_REQUIRED)
    }),
    distance: Yup.number().when("kennel", {
      is: FormConst.VALUE_NEARBY,
      then: Yup.number()
        .required(FormConst.VALIDATION_ERROR_REQUIRED)
        .min(0.0001, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO)
    })
  })

  handleSubmit(data) {
    let petPolicy = {}

    if (data.isPets) {
      petPolicy.petsAllowed = data.isPets
      petPolicy.amenityCode = FormConst.AMENITY_CODE_PETS

      let charge = {}

      if (data.isPetsCharged) {

        let chargeTypeValue
        let chargeFrequency

        switch (data.chargeType) {
          case "Per Pet Per Night":
            chargeTypeValue = "Per Pet"
            chargeFrequency = "Per Night"
            break;
          case "Per Pet Per Stay":
            chargeTypeValue = "Per Pet"
            chargeFrequency = "Per Stay"
            break;
          case "Fixed Amount Per Night":
            chargeTypeValue = "Fixed Amount"
            chargeFrequency = "Per Night"
            break;
          case "Fixed Amount Per Stay":
            chargeTypeValue = "Fixed Amount"
            chargeFrequency = "Per Stay"
            break;
        }
        charge.amount = data.chargeAmount
        charge.chargeType = chargeTypeValue
        charge.frequency = chargeFrequency
      } else {
        charge.amount = 0
        charge.chargeType = "Per Pet"
        charge.frequency = "Per Stay"
      }
      petPolicy.charge = charge
      if (data.isDeposit) {
        petPolicy.deposit = {
          amount: data.depositAmount,
          frequency: data.depositFrequencyType,
          refundable: data.depositRefundable
        }
      }
      if (data.kennel == FormConst.VALUE_NEARBY || data.kennel == FormConst.VALUE_ONSITE) {
        petPolicy.kennel = {
          amenityCode: FormConst.AMENITY_CODE_KENN,
          distanceDescription: data.kennel,
          distanceValue: data.distance,
          distanceUnit: this.state.distanceUnitsLabel
        }
      }
      if (data.maxPetCount) {
        petPolicy.maxPetCount = data.petCount
      } else {
        petPolicy.maxPetCount = 0
      }
      if (data.maxPetSize) {
        petPolicy.maxPetSize = data.petSize
        petPolicy.weightUnit = this.state.weightUnit
      }
    } else {
      petPolicy.petsAllowed = data.isPets
      petPolicy.amenityCode = FormConst.AMENITY_CODE_NPET
    }
    this.props.onPut({ hotelCode: this.state.hotelCode, petPolicy: petPolicy })

    this.setState({
      isLoading: true,
      loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT
    })
  }

  handleClearForm = () => {
    this.setState({ showResetModal: true })
  }

  resetFormData = (formikResetFormMethod) => {
    formikResetFormMethod()
    this.setState({
      showResetModal: false
    })
  }

  async componentDidMount() {
    if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
      let petPolicy = this.state.hotelInfoCompletedHistory.newEntity.petPolicies.petPolicy;
      if (!isObjectEmpty(petPolicy)) {
        let initialValues = {
          isPets: petPolicy.amenityCode === FormConst.AMENITY_CODE_PETS,
          maxPetCount: !!petPolicy.maxPetCount,
          petCount: petPolicy.maxPetCount,
          maxPetSize: !!petPolicy.maxPetSize,
          petSize: petPolicy.maxPetSize
        }
        if (petPolicy.charge) {
          initialValues.isPetsCharged = petPolicy.charge.amount !== 0;
          initialValues.chargeAmount = petPolicy.charge.amount;
          initialValues.chargeType = petPolicy.charge.chargeType + ' ' + petPolicy.charge.frequency;
        }
        if (petPolicy.deposit) {
          initialValues.isDeposit = petPolicy.deposit !== undefined;
          initialValues.depositAmount = petPolicy.deposit ? petPolicy.deposit.amount : 0;
          initialValues.depositFrequencyType = petPolicy.deposit ? petPolicy.deposit.frequency : '';
          initialValues.depositRefundable = petPolicy.deposit ? petPolicy.deposit.refundable : false;
        }
        if (petPolicy.kennel) {
          initialValues.kennel = petPolicy.kennel ? petPolicy.kennel.distanceDescription : this.state.initialValues.kennel;
          initialValues.distance = petPolicy.kennel ? petPolicy.kennel.distanceValue : 0;
        }
        this.setState({
          isLoading: false,
          initialValues: initialValues
        })
      } else {
        this.setState({ isLoading: false })
      }
    } else {
      await PetPolicyService.getPetPolicy({ hotelCode: this.state.hotelCode })
          .then(response => {
            if (!isObjectEmpty(response?.petPolicy)) {
              let policy = response.petPolicy
              let initialValues = {
                isPets: policy.amenityCode === FormConst.AMENITY_CODE_PETS,
                isPetsCharged: policy.charge.amount !== 0,
                chargeAmount: policy.charge.amount,
                chargeType: policy.charge.chargeType + ' ' + policy.charge.frequency,
                isDeposit: policy.deposit !== undefined,
                depositAmount: policy.deposit ? policy.deposit.amount : 0,
                depositFrequencyType: policy.deposit ? policy.deposit.frequency : '',
                depositRefundable: policy.deposit ? policy.deposit.refundable : false,
                kennel: policy.kennel ? policy.kennel.distanceDescription : this.state.initialValues.kennel,
                distance: policy.kennel ? policy.kennel.distanceValue : 0,
                maxPetCount: !!policy.maxPetCount,
                petCount: policy.maxPetCount,
                maxPetSize: !!policy.maxPetSize,
                petSize: policy.maxPetSize
              }
              this.setState({
                isLoading: false,
                initialValues: initialValues
              })
            } else {
              this.setState({ isLoading: false })
            }
          }).catch(error => {
            this.setState({
              isLoading: false,
              showErrorModal: true,
              errorMessage: 'There was an error while retrieving Pet Policy data',
            })
          })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.count !== this.props.count) {
      if (this.props.errorMessage) {
        this.setState({
          isLoading: false,
          showErrorModal: true,
          errorMessage: this.props.errorDescription
        })
      } else {
        // Continue to next form
        if (this.state.continueFlow) {
          // Go to the next page
          this.props.history.push({
            pathname: RouteConst.ROUTE_GROUP_POLICY_PAGE,
            state: {
              continueFlow: this.state.continueFlow
            }
          })
        } else {
          // Go back to hotel policies page
          this.props.history.push(RouteConst.ROUTE_POLICIES_PAGE)
        }
      }
    }
  }

  render() {
    return (
      <div className='pet-policies-page'>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
            <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_POLICIES_PAGE}>Policies</NavLink></li>
            <li className="breadcrumb-item active" aria-current="page">Pet Policy</li>
          </ol>
        </nav>
        <p className='pet-policy-helper-text'>This section is to submit Pet Policy details.</p>
        <Formik
          initialValues={this.state.initialValues}
          validationSchema={this.validationSchema}
          enableReinitialize={true}
          onSubmit={(data, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            this.handleSubmit(data);
            setSubmitting(false);
          }}
          onReset={this.handleReset}
        >
          {({ values, isSubmitting, dirty, handleChange, resetForm }) => (
            <Form className='pet-policies-form-element'>
              <div className='pet-policies-form-fields' >
                <ToggleSwitch
                  id='isPets'
                  name='isPets'
                  label='Does your hotel allow pets?'
                  checked={values.isPets}
                  options={FormConst.SWITCH_OPTIONS_YES_NO}
                  value='false'
                  onChange={handleChange}
                  isrequired='true' />

                {
                  values.isPets &&
                  (
                    <>
                      <div>
                        <p className='pet-policies-title'>Charge Details</p>
                        <ToggleSwitch
                          id='isPetsCharged'
                          name='isPetsCharged'
                          checked={values.isPetsCharged}
                          label='Do you charge for pets?'
                          options={FormConst.SWITCH_OPTIONS_YES_NO}
                          onChange={handleChange}
                          isrequired='true' />
                        {
                          values.isPets && values.isPetsCharged && (
                            <>
                              <TextInput
                                name='chargeAmount'
                                type='number'
                                min='0.00'
                                step='0.5'
                                max='2500'
                                placeholder='0.00'
                                value={parseFloat(values.chargeAmount)}
                                label={`Charge Amount in ${this.state.hotelCurrency}`}
                                isrequired='true' />
                              <SelectInput id='chargeType' name='chargeType' label='Charge Frequency' options={FormConst.PET_POLICY_CHARGE_TYPE} isrequired='true' />
                            </>
                          )
                        }
                      </div>
                      <div>
                        <p className='pet-policies-title'>Deposit Details</p>
                        <ToggleSwitch
                          id='isDeposit'
                          name='isDeposit'
                          checked={values.isDeposit}
                          label='Do you require a deposit for pets?'
                          options={FormConst.SWITCH_OPTIONS_YES_NO}
                          onChange={handleChange}
                          isrequired='true' />
                        {values.isPets && values.isDeposit && (
                          <>
                            <TextInput
                              name='depositAmount'
                              type='number'
                              min='0.00'
                              step='0.5'
                              max='2500'
                              placeholder='0.00'
                              value={parseFloat(values.depositAmount)}
                              label={`Deposit Amount(per Pet) in ${this.state.hotelCurrency}`}
                              isrequired='true' />
                            <SelectInput id='depositFrequencyType' name='depositFrequencyType' label='Deposit Frequency' options={FormConst.PET_POLICY_DEPOSIT_FREQUENCY_TYPE} isrequired='true' />
                            <ToggleSwitch
                              id='depositRefundable'
                              name='depositRefundable'
                              checked={values.depositRefundable}
                              label='Is deposit refundable?'
                              options={FormConst.SWITCH_OPTIONS_YES_NO}
                              onChange={handleChange}
                              isrequired='true' />
                          </>
                        )}
                      </div>
                      <div>
                        <p className='pet-policies-title'>Pet Count Details</p>
                        <ToggleSwitch
                          id='maxPetCount'
                          name='maxPetCount'
                          checked={values.maxPetCount}
                          label='Do you limit the number of pets?'
                          options={FormConst.SWITCH_OPTIONS_YES_NO}
                          onChange={handleChange}
                          isrequired='true' />
                        {values.isPets && values.maxPetCount && (
                          <>
                            <TextInput
                              id='petCount'
                              name='petCount'
                              type='number'
                              min='0'
                              step='1'
                              max='2500'
                              placeholder='0'
                              label='Count limit'
                              isrequired='true' />
                          </>
                        )}
                      </div>
                      <div>
                        <ToggleSwitch
                          id='maxPetSize'
                          name='maxPetSize'
                          checked={values.maxPetSize}
                          label='Do you limit the size of each pet?'
                          options={FormConst.SWITCH_OPTIONS_YES_NO}
                          onChange={handleChange}
                          isrequired='true' />
                        {values.isPets && values.maxPetSize && (
                          <>
                            <TextInput
                              id='petSize'
                              name='petSize'
                              type='number'
                              min='0'
                              step='0.5'
                              max='2500'
                              placeholder='0'
                              label={`Size limit (in ${this.state.weightUnit})`}
                              isrequired='true' />
                          </>
                        )}
                      </div>
                      <div>
                        <p className='pet-policies-title'>Kennel Details</p>
                        <SelectInput id='kennel' name='kennel' label='Is the kennel in or near the hotel?'
                          options={FormConst.KENNEL_OPTIONS_ONSITE_NEARBY} />
                        {
                          values.kennel === FormConst.VALUE_NEARBY
                          && (
                            <TextInput
                              id='distance'
                              name='distance'
                              type='number'
                              min='0'
                              step='0.5'
                              max='2500'
                              placeholder='0'
                              label={`Distance from hotel (${this.state.distanceUnitsLabel})`}
                              isrequired='true' />
                          )
                        }
                      </div>
                    </>
                  )
                }
              </div>
              <FormFooter
                form={
                  {
                    previous: { title: 'Guarantee & Cancel Policy', route: RouteConst.ROUTE_GUARANTEE_CANCEL_POLICY_PAGE },
                    next: { title: 'Group Policy', route: RouteConst.ROUTE_GROUP_POLICY_PAGE }
                  }
                }
                isSubmit
                submitName={FormConst.SAVE_BUTTON_TEXT}
                resetName={FormConst.RESET_BUTTON_TEXT}
                onReset={this.handleClearForm}
                submitDisabled={isSubmitting} />
              <FormModal
                id='pet-policies-page-save-modal'
                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                hotelInfo={this.state.hotelInfo}
                body={<h6>{this.state.loadingMessage}</h6>}
                show={this.state.isLoading}
                isLoadingIndicator />
              <FormModal
                id='pet-policies-page-reset-modal'
                hotelInfo={this.state.hotelInfo}
                title={FormConst.MODAL_RESET_ACTION_TITLE}
                body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                proceed={() => {
                  this.resetFormData(resetForm)
                }}
                cancel={() => { this.setState({ showResetModal: false }) }}
                show={this.state.showResetModal} />
              <FormModal
                id='pet-policies-page-error-modal'
                hotelInfo={this.state.hotelInfo}
                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                body={<h5>{this.state.errorMessage}</h5>}
                isError
                cancel={() => { this.setState({ showErrorModal: false }) }}
                show={this.state.showErrorModal} />
            </Form>
          )}
        </Formik>
      </div>
    )
  }
}
// Sample redux dispatch
const mapStateToProps = state => {
  return {
    petPoliciesResponse: state.reducer.response,
    errorMessage: state.reducer.errorMessage,
    errorDescription: state.reducer.errorDescription,
    count: state.reducer.count
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onPut: (data) => dispatch(asyncMethod(FormConst.FORM_PET_POLICY_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(PetPolicy, SideNavEntryMapping.HOTEL_POLICIES))